/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Row, Container } from "reactstrap";

function DemoFooter() {
  return (
    <footer className="footer footer-black footer-white" style={{
      background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
      boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
      padding: "20px 0"
    }}>
      <Container>
          <div className="credits text-center">
            <span className="copyright" style={{
              fontSize: "13px",
              color: "rgba(255, 255, 255, 0.7)",
              fontWeight: "400"
            }}>
              © {new Date().getFullYear()}, Kinesitherapie Notebaert - Standaert, with
              <i className="fa fa-heart heart" style={{ color: "#69be50", margin: "0 5px" }} /> by edisonn.io
            </span>
          </div>
      </Container>
    </footer>
  );
}

export default DemoFooter;
